import { render, staticRenderFns } from "./CardAssigned.vue?vue&type=template&id=ddae5e52"
import script from "./CardAssigned.vue?vue&type=script&lang=js"
export * from "./CardAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports